import React from 'react'
import { Link } from 'react-router-dom'
import axios from 'axios'
import Constant from '../../Constant'
import Swal from 'sweetalert2'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Paper from '@material-ui/core/Paper'
import Loader from '../../common/Loader'

class CruiseFacilities extends React.Component {
  state = {
    formAction: 'add',
    formData: {
      name_en: '',
      name_ar: '',
      type: '',
      image: null,
    },
    list: [],
    isListLoading: false,
    isSaving: false,
  }

  componentDidMount() {
    this.loadData()
  }

  loadData = async () => {
    this.setState({ isListLoading: true })
    let list = await axios.get(Constant.getAPI() + '/admin/get-facilities/all', {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
        country_short_name: `${localStorage.getItem('countryShortName')}`,
      },
    })

    if (list.status === 200 && list.data && list.data.data && list.data.data.length > 0) {
      this.setState({
        list: list.data.data,
        isListLoading: false,
      })
    } else {
      this.setState({
        isListLoading: false,
      })
    }
  }

  handleChange = (event) => {
    this.setState({
      formData: {
        ...this.state.formData,
        [event.target.name]: event.target.value,
      },
    })
  }

  handleChangeImage = (event) => {
    this.setState({
      formData: {
        ...this.state.formData,
        [event.target.name]: event.target.files[0],
      },
    })
  }

  delete = async (id) => {
    await axios
      .delete(Constant.getAPI() + '/admin/dashboard-message/' + id, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.statusCode === 200) {
          Swal.fire({
            title: 'Deleted Successfully!',
            icon: 'success',
            text: '',
            type: 'success',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })

          this.setState({
            list: this.state.list.filter((item) => item.id !== id),
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  onSave = async () => {
    this.setState({ isSaving: true })

    const formData = new FormData()
    formData.append('name_en', this.state.formData.name_en)
    formData.append('name_ar', this.state.formData.name_ar)
    formData.append('type', this.state.formData.type)

    if (this.state.formData.image && typeof this.state.formData.image == 'object') {
      formData.append('image', this.state.formData.image)
    }

    var request
    if (this.state.formAction === 'add') {
      request = axios.post(Constant.getAPI() + '/admin/add-facilities', formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
    } else {
      request = axios.put(Constant.getAPI() + '/admin/update-facilities/' + this.state.formData.id, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
    }

    request
      .then((data) => {
        if (data.status === 200 && data.data) {
          Swal.fire({
            title: this.state.formAction === 'add' ? 'Successfully created.' : 'Successfully updated.',
            icon: 'success',
            text: '',
            type: 'success',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })

          this.onClear()
          this.loadData()
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({
          isSaving: false,
        })
      })
  }

  onEdit = async (id) => {
    const selectedRecord = this.state.list.find((item) => item.id === id)

    if (selectedRecord) {
      this.setState({
        formAction: 'edit',
        formData: {
          id: selectedRecord.id,
          name_en: selectedRecord.name_en,
          name_ar: selectedRecord.name_ar,
          image: selectedRecord.image,
          type: selectedRecord.type,
        },
      })
    }
  }

  onClear = () => {
    this.setState(
      {
        isSaving: false,
        formAction: 'add',
        formData: {
          name_en: '',
          name_ar: '',
          type: '',
          image: null,
        },
      },
      () => {
        this.image_input.value = null
      }
    )
  }

  render() {
    return (
      <div className="main-body">
        <div className="page-wrapper">
          <div className="page-header">
            <div className="row align-items-end">
              <div className="col-lg-8">
                <div className="page-header-title">
                  <div className="d-inline">
                    <h4>Facilities</h4>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="page-header-breadcrumb">
                  <ul className="breadcrumb-title">
                    <li className="breadcrumb-item">
                      <Link to="/">
                        <i className="feather icon-home"></i>{' '}
                      </Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to={`/cruise-facilities`}>Facilities</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="page-body">
            <div className="row">
              <div className="col-sm-12">
                <div className="card card-border-default">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-md-3 col-form-label">Name English:</label>
                          <div className="col-md-9">
                            <input
                              type="text"
                              className="form-control"
                              value={this.state.formData.name_en}
                              name="name_en"
                              onChange={this.handleChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-md-3 col-form-label">Name Arabic:</label>
                          <div className="col-md-9">
                            <input
                              type="text"
                              className="form-control"
                              value={this.state.formData.name_ar}
                              name="name_ar"
                              onChange={this.handleChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-md-3 col-form-label">Type:</label>
                          <div className="col-md-9">
                            <select
                              name="type"
                              className="form-control"
                              onChange={this.handleChange}
                              value={this.state.formData.type}
                            >
                              <option value="">Select Type</option>
                              <option value="CRUISE">Cruise</option>
                              <option value="CHALET">Chalet</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="row">
                          <div className="col-sm-3">Image</div>
                          <div className="col-sm-6">
                            <div className="form-group">
                              <div>
                                <input
                                  type="file"
                                  id="img"
                                  name="image"
                                  accept="image/*"
                                  className="w-100"
                                  onChange={this.handleChangeImage}
                                  ref={(ref) => (this.image_input = ref)}
                                />
                              </div>
                            </div>
                            {this.state.formData &&
                              this.state.formData.image &&
                              (typeof this.state.formData.image == 'object' ? (
                                <img
                                  style={{ border: '1px solid #ddd' }}
                                  width="100px"
                                  src={URL.createObjectURL(this.state.formData.image)}
                                  alt="img"
                                />
                              ) : (
                                <img
                                  width="100px"
                                  src={Constant.getImage() + this.state.formData.image}
                                  alt="img"
                                />
                              ))}
                          </div>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="row">
                          <div className="text-right col-6 offset-6">
                            {this.state.isSaving ? (
                              <button
                                className="btn btn-grd-disabled mr-2"
                                disabled
                              >
                                Saving...!
                              </button>
                            ) : (
                              <>
                                <button
                                  onClick={this.onSave}
                                  className="btn hor-grd btn-grd-inverse offset-1"
                                >
                                  <i className="ti-save"></i>
                                  {this.state.formAction === 'add' ? 'Save' : 'Update'}
                                </button>
                                <button
                                  onClick={this.onClear}
                                  className="btn hor-grd btn-grd-inverse m-l-10"
                                >
                                  Clear
                                </button>
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {this.state.formAction != 'edit' && (
            <>
              <div className="page-header">
                <div className="row align-items-end">
                  <div className="col-lg-8">
                    <div className="page-header-title">
                      <div className="d-inline">
                        <h4>Facility list</h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="page-body">
                <div className="row">
                  <div className="col-12">
                    <div className="card card-border-default">
                      <div className="card-block">
                        <div className="dt-responsive table-responsive">
                          <TableContainer component={Paper}>
                            <Table aria-label="simple table">
                              <TableHead>
                                <TableRow>
                                  <TableCell
                                    className="col-4"
                                    style={{ fontWeight: 'bold' }}
                                  >
                                    Name English
                                  </TableCell>
                                  <TableCell
                                    className="col-3"
                                    style={{ fontWeight: 'bold' }}
                                  >
                                    Name Arabic
                                  </TableCell>
                                  <TableCell
                                    className="col-2"
                                    style={{ fontWeight: 'bold' }}
                                  >
                                    Type
                                  </TableCell>
                                  <TableCell
                                    className="col-2"
                                    style={{ fontWeight: 'bold' }}
                                  >
                                    Image
                                  </TableCell>
                                  <TableCell
                                    className="col-1"
                                    style={{ width: 70, fontWeight: 'bold' }}
                                  >
                                    Actions
                                  </TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {!this.state.isListLoading &&
                                  this.state.list.map((row) => (
                                    <TableRow key={row.id}>
                                      <TableCell>{row.name_en}</TableCell>
                                      <TableCell>{row.name_ar}</TableCell>
                                      <TableCell>{row.type}</TableCell>
                                      <TableCell>
                                        <img
                                          src={Constant.getImage() + row.image}
                                          className="img-fluid img-50"
                                          alt="img"
                                          onError={(event) => {
                                            event.currentTarget.src = './assets/images/no_image.png'
                                          }}
                                        />
                                      </TableCell>
                                      <TableCell>
                                        <div className="d-flex">
                                          <div
                                            onClick={() => {
                                              this.onEdit(row.id)
                                            }}
                                          >
                                            <i className="f-20 icofont icofont-ui-edit text-custom m-r-10"></i>
                                          </div>
                                          {/* <div onClick={() => {this.delete(row.id)}}>
                                              <i className="f-20 icofont icofont-delete-alt text-danger"></i>
                                            </div> */}
                                        </div>
                                      </TableCell>
                                    </TableRow>
                                  ))}
                              </TableBody>
                            </Table>
                          </TableContainer>
                          {!this.state.isListLoading && this.state.list.length === 0 && (
                            <div className="row p-10">
                              <div className="col-12 text-center">Sorry, No Record Found</div>
                            </div>
                          )}
                          {this.state.isListLoading && (
                            <div className="row p-10">
                              <div className="col-12 text-center">
                                <Loader open={this.state.isListLoading} />
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    )
  }
}

export default CruiseFacilities
